/**
 * @module App
 * @summary Root component: shows the login screen until authenticated, then the
 *   editor shell. (Auth is a client-side UX gate — see lib/auth.)
 */
import { useAuthStore } from './state/authStore';
import { LoginScreen } from './components/auth/LoginScreen';
import { AppShell } from './components/layout/AppShell';

export default function App() {
  const user = useAuthStore((s) => s.user);
  return user ? <AppShell /> : <LoginScreen />;
}
